import React from "react"
import { EditorState, Modifier, RichUtils } from "draft-js"
import { fontColorStyleMap } from "../../../../../../libs/style-map"
import styled from "styled-components"
import { IToolBarProps } from "."
import { FONT_COLOR_STYLE_MAP_WITH_BUTTON_TITLE } from "../../../../../../libs/style-info"
import { FONT_COLOR } from "../../../../../../../../../../style/const/chat/inline_style"

export const FontColorButton = (props: IToolBarProps) => {
  const toggleColor = (toggledColor: FONT_COLOR | null) => {
    const editorState = props.editorState
    const selection = editorState.getSelection()
    const currentStyle = editorState.getCurrentInlineStyle()

    const nextContentState = Object.keys(fontColorStyleMap).reduce(
      (contentState, color) =>
        Modifier.removeInlineStyle(contentState, selection, color),
      editorState.getCurrentContent(),
    )

    let nextEditorState = EditorState.push(
      editorState,
      nextContentState,
      "change-inline-style",
    )

    if (toggledColor && !currentStyle.has(toggledColor)) {
      nextEditorState = RichUtils.toggleInlineStyle(
        nextEditorState,
        toggledColor,
      )
    }

    props.onChange(nextEditorState)
  }
  return (
    <Wrapper>
      {FONT_COLOR_STYLE_MAP_WITH_BUTTON_TITLE.map(style => {
        const func = () => toggleColor(style.label)
        return (
          <ColorButton
            key={style.colorCode}
            onClick={func}
            color={style.colorCode}
          />
        )
      })}
    </Wrapper>
  )
}

const Wrapper = styled.div`
  line-height: 1;
`

const ColorButton = styled.button<{
  color: string
}>`
  background-color: ${({ color }) => color};
  width: 25px;
  height: 25px;
  border: none;
  border-radius: 12.5px;
  margin-right: 5px;
`
